import { RiArrowDownSLine } from 'react-icons/ri'

function LocationFilter({

    showLocationFilter, setShowLocationFilter, setShowCostFilter,
    selectedDivision, setSelectedDivision,
    selectedDistrict, setSelectedDistrict,
    selectedArea, setSelectedArea,
    divisions, districts, areas,
    consumer

}) {

    return (
        <div className="filter_category">
            <button 
                type='button' 
                className={`${showLocationFilter ? 'show' : ''}`} 
                onClick={() => {
                    setShowLocationFilter(prevState => !prevState)
                    setShowCostFilter(false)
                }}
            >
                <span>
                    {
                        consumer
                        ?
                            consumer.language === 'english'
                            ?
                                'Location'
                            :
                                'লোকেশন'
                        :
                            'লোকেশন'
                    }
                    {/* <span className='badge'>2</span> */}
                </span>
                <RiArrowDownSLine />
            </button>
            <div className={`collapse divisions ${showLocationFilter ? 'show' : ''}`}>
                <div className="radio_input">
                    <input
                        type="radio"
                        value='all-divisions'
                        checked={selectedDivision === 'all-divisions'}
                        onChange={e => setSelectedDivision(e.target.value)}
                    />
                    <label>
                        {
                            consumer
                            ?
                                consumer.language === 'english'
                                ?
                                    'All Divisions'
                                :
                                    'সকল বিভাগ'
                            :
                                'সকল বিভাগ'
                        }
                    </label>
                </div>
                {divisions?.map(division => (
                    <div key={division._id}>
                        <div className={`radio_input ${selectedDivision === division._id ? 'selected' : ''}`}>
                            <input
                                type="radio"
                                value={division._id}
                                checked={selectedDivision === division._id}
                                onChange={e => setSelectedDivision(e.target.value)}
                            />
                            <label>
                                {
                                    consumer
                                    ?
                                        consumer.language === 'english'
                                        ?
                                            division.name
                                        :
                                            division.bngName
                                    :
                                        division.bngName
                                }
                            </label> &nbsp;
                            <RiArrowDownSLine />
                        </div>

                        <div className={`collapse districts ${selectedDivision === division._id ? 'show' : ''}`}>
                            <div className="radio_input">
                                <input
                                    type="radio"
                                    value='all-districts'
                                    checked={selectedDistrict === 'all-districts'}
                                    onChange={e => setSelectedDistrict(e.target.value)}
                                />
                                <label>
                                    {
                                        consumer
                                        ?
                                            consumer.language === 'english'
                                            ?
                                                'All Districts'
                                            :
                                                'সকল জেলা'
                                        :
                                            'সকল জেলা'
                                    }
                                </label>
                            </div>
                            {
                                districts?.filter(district => district.division === division._id).map(d => (
                                    <div key={d._id}>
                                        <div className={`radio_input ${selectedDistrict === d._id ? 'selected' : ''}`}>
                                            <input type="radio"
                                                value={d._id}
                                                checked={selectedDistrict === d._id}
                                                onChange={e => setSelectedDistrict(e.target.value)}
                                            />
                                            <label>
                                                {
                                                    consumer
                                                    ?
                                                        consumer.language === 'english'
                                                        ?
                                                            d.name
                                                        :
                                                            d.bngName
                                                    :
                                                        d.bngName
                                                }
                                            </label> &nbsp;
                                            <RiArrowDownSLine />
                                        </div>
                                        <div className={`collapse areas ${selectedDistrict === d._id ? 'show' : ''}`}>
                                            <div className="radio_input">
                                                <input
                                                    type="radio"
                                                    value='all-areas'
                                                    checked={selectedArea === 'all-areas'}
                                                    onChange={e => setSelectedArea(e.target.value)}
                                                />
                                                <label>
                                                    {
                                                        consumer
                                                        ?
                                                            consumer.language === 'english'
                                                            ?
                                                                'All Areas'
                                                            :
                                                                'সকল এলাকা'
                                                        :
                                                            'সকল এলাকা'
                                                    }
                                                </label>
                                            </div>
                                            {areas?.filter(area => area.district === d._id).map(a => (
                                                <div className="radio_input" key={a._id}>
                                                    <input type="radio"
                                                        value={a._id}
                                                        checked={selectedArea === a._id}
                                                        onChange={e => setSelectedArea(e.target.value)}
                                                    />
                                                    <label>
                                                    {
                                                        consumer
                                                        ?
                                                            consumer.language === 'english'
                                                            ?
                                                                a.name
                                                            :
                                                                a.bngName
                                                        :
                                                            a.bngName
                                                    }
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                ))}

        
            </div>
        </div>
    )
}

export default LocationFilter